import { paths } from "helpers/paths";
import { formatNumber } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";

export default function BidsTable({ data }) {
    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>Заявка</th>
                    <th>Название</th>
                    <th>Сумма</th>
                </tr>
            </thead>
            <tbody>
                {data?.length ? (
                    data.map((el, index) => {
                        return (
                            <tr key={index}>
                                <td>
                                    <Link to={paths.bidShow("bid", el.bidId)} target="_blank">
                                        {el.bidId}
                                    </Link>
                                </td>
                                <td>{el.name}</td>
                                <td>
                                    {formatNumber(el.value, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={3} className="text-center">
                            Нет данных
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
